export default "__VITE_ASSET__3bc76c5d__"